import type { AchBatchImportModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export interface AchFileUploadResult {
    filename: string;
    count: number;
}

export interface AchUploadError {
    line: string;
    lineNumber: string;
    message: string;
}

export type AchFileUploadStatus =
    | 'Uploaded'
    | 'Queued'
    | 'In Progress'
    | 'Done'
    | 'Stalled'
    | 'Error';

export interface AchRecentFile {
    fileName: string;
    fileStatus: AchFileUploadStatus;
    uploadedDateTime: string;
}

export interface AchUpload422Response {
    type: string;
    title: string;
    details: string[];
    data: { errors: AchUploadError[] };
}

export class AchBatchImport extends DomainEntity<AchBatchImportModelDto> {
    public get hasError(): boolean {
        const hasBatches = (this.dto.achBatchSummaries?.length ?? 0) > 0;
        const hasErrorMessage = !!this.dto.errorMessage;
        return !hasBatches || hasErrorMessage;
    }

    public get errorMessage(): string {
        return this.dto.errorMessage ?? 'The file could not be processed.';
    }

    public toUploadResult(filename: string): AchFileUploadResult {
        return {
            filename,
            count: this.dto.achBatchSummaries?.length ?? 0,
        };
    }

    public createDefault(): this {
        return new AchBatchImport({} as AchBatchImportModelDto) as this;
    }
}
